<template>
  <div class="cookies" v-if="show == 'true'">
    <div class="left">
      <a @click="hideCookie">&times;</a>
    </div>
    <div class="right">
      Our website uses cookies to give you the best experience possible.  By closing this message or continuing to use our website, you consent to us using cookies on this device in accordance with our <a href="/static/pdf/XPLORA_Cookie_policy_17_04_2018.pdf" target="_blank">Cookies policy</a>
    </div>
  </div>
</template>

<script>

import { EventBus } from './EventBus.js'

export default {
  name: 'cookies',
  components: {
    
  },
  data () {
    return {
      show: 'false'
    }
  },
  mounted () {
    if (this.getCookie('cookieBar') != "")
    {
      this.show = this.getCookie('cookieBar');
    }
    else
    {
      this.show = 'true';
    }
  },
  methods: {
    hideCookie() {
      this.setCookie('cookieBar', 'false', 90);
      this.show = 'false';
    },
    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .cookies {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: auto;
    background: #3c434c;
    color: #fff;
    padding: 10px;
    border-top: 1px solid #666;
  }
  .left {
    width: 30px;
    display: inline-block;
    float: left;
    font-size: 32px;
  }
  a {
    cursor: pointer;
  }
  .right {
    width: calc(100% - 140px);
    display: inline-block;
    float: left;
    font-size: 14px;
  }

@media (max-width: 520px) {
  .cookies {
    padding: 10px;
  }
  .right {
    width: calc(100% - 90px);
    display: inline-block;
    float: left;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cookies.vue